export const APP = `${window.origin}`;
export const USER_ID = `${APP}:USER:ID`;
export const TENANT_KEY = `${APP}:TENANT:KEY`;
export const IS_CUSTOM_LOGIN = `${APP}:CUSTOM:LOGIN`;
export const IS_MSAL_LOGIN = `${APP}:MSAL:LOGIN`;
export const CLIENT_ID = `${APP}:CLIENT:ID`;
export const USER_INFO = `${APP}:USER:INFO`;
export const USER_ROLES = `${APP}:USER:ROLES`;
export const USER_TEAMS = `${APP}:USER:TEAMS`;
export const USER_TOKEN_INFO = `${APP}:USER:TOKEN:INFO`;
export const POST_AUTH_TOKEN_INFO = `${APP}:POST:AUTH:TOKEN:INFO`;
export const SELECTED_LANGUAGE = `${APP}:USER:SELECTED::LANGUAGE`;
export const BOT_TOKEN_INFO = `${APP}:BOT:TOKEN:INFO`;
export const MICROSOFT_TOKEN_INFO = `${APP}:MICROSOFT:TOKEN:INFO`;
export const BOT_CONVERSATION_INFO = `${APP}:BOT:CONVERSATION:INFO`;
export const IS_FUNCTIONAL = `${APP}:USER:ROLE:FUNCTIONAL`;
export const IS_PROFILE_EDITOR = `${APP}:USER:ROLE:PROFILE:EDITOR`;
export const IMPORT_ROLE = `${APP}:USER:ROLE:IMPORT`;
export const TRAINING_DOC = `${APP}:USER:TRAINING:DOC:IMPORT`;
export const IS_JOURNEY_ADMIN = `${APP}:USER:ROLE:JOURNEY:ADMIN`;
export const CLIENT_PREFERNCE_KEY = `${APP}:CLIENT_PREFERNCE`;
export const CLIENT_WEEK_START_DAY = `${APP}:CLIENT_WEEK_START_DAY`;
export const USER_PHOTO_URL = `${APP}:CLIENT_WEEK_START_DAY`;
export const IS_WORKER = `${APP}:IS:WORKER`;
export const IS_TENANTS_ADMIN = `${APP}:USER:ROLE:TENANTS:ADMIN`;
export const DontShow_POP_UP = `${APP}:Dont_Show_Again`;
export const Selected_Currency = `${APP}:Selected_Currency`;
export const IS_TURTLE_LOGIN = `${APP}:TURTLE:LOGIN`;
export const USER_PROFILE = `${APP}:USER:PROFILE`;
export const USER_PREFERNCE_KEY = 'USER_PREFERNCES';
export const CLIENT_INFO = `${APP}:CLIENT_INFO`;
export const EMPOWER_REPORT_MODERN_LIFE = 'MODERN_LIFE';
export const EMPOWER_REPORT_GAMING = 'GAMING';
export const NO_IMAGE = 'NO_IMAGE';
export const CLIENT_LANDING_PAGE_PREFERENCE = 'CLIENT_LANDING_PAGE_PREFERENCE';
export const USER_CLIENT_TOKEN_INFO = `${APP}:USER:CLIENT:TOKEN:INFO`;
export const USER_CLIENT_REFRESH_INFO = `${APP}:USER:CLIENT:REFRESH:INFO`;
export const USER_THREAD_ID = `${APP}:USER_THREAD_ID`;
export const INPUT_HISTORY = `${APP}:INPUT_HISTORY`;
export const ALL_CLIENT_CONFIGURATION = `${APP}:ALL_CLIENT_CONFIGURATION`;
export const IS_ONE_ALGO_ENGINE_ENABLED = `ONE_ALGO_ENGINE_ENABLED`;
export const CHAT_ENABLED = `CHAT_ENABLED`;
export const TENANTS_LIST = `TENANTS_LIST`;
export const IS_SCHEDULER_ADMIN = `${APP}:USER:ROLE:SCHEDULER:ADMIN`;